import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { usePersonUpcomingItems } from '@/hooks/usePersonUpcomingItems';

interface AvatarWithNotificationProps {
  src?: string | null;
  alt?: string;
  fallback?: React.ReactNode;
  className?: string;
  personId?: string;
  profileId?: string;
  showNotification?: boolean;
  children?: React.ReactNode;
}

export function AvatarWithNotification({
  src,
  alt,
  fallback,
  className,
  personId,
  profileId,
  showNotification = true,
  children,
  ...props
}: AvatarWithNotificationProps) {
  const { upcomingCount, hasUpcomingItems } = usePersonUpcomingItems(personId, profileId);

  return (
    <div className="relative">
      <Avatar className={className} {...props}>
        <AvatarImage src={src || ''} alt={alt} />
        <AvatarFallback>{fallback}</AvatarFallback>
      </Avatar>
      
      {showNotification && hasUpcomingItems && (
        <Badge 
          className={cn(
            "absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center",
            "text-white text-xs font-medium rounded-full",
            "border-0"
          )}
          style={{ backgroundColor: '#07b84a' }}
        >
          {upcomingCount > 9 ? '9+' : upcomingCount}
        </Badge>
      )}
      
      {children}
    </div>
  );
}